export default __webpack_public_path__ + "static/media/Bunche.ALK.61e28813.jpg";